import React, { useEffect, useState } from "react";
import { Box, Typography, Button, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import {
  fetchApplicationCategory,
  fetchDataCategoriesByBusinessUnit,
  addApplicationCategoryDataCategory,
} from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function ApplicationCategoryDataCategoryAddPage() {
  const { businessDomainId, categoryId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [dataCategories, setDataCategories] = useState([]);
  const [selectedId, setSelectedId] = useState("");

  const basePath = `/strategy/${businessDomainId}/application-categories/${categoryId}`;

  useEffect(() => {
    (async () => {
      try {
        const cat = await fetchApplicationCategory(categoryId);
        const businessUnitId = cat.businessUnitId;
        if (!businessUnitId) return;
        const all = await fetchDataCategoriesByBusinessUnit(businessUnitId);
        const existing = new Set((cat.dataCategories || []).map((dc) => dc.dataCategoryId));
        setDataCategories((Array.isArray(all) ? all : []).filter((dc) => !existing.has(dc.dataCategoryId)));
      } catch (e) { notify.apiError(e); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedId) {
      notify.error(t("applicationCategory.dataCategory.selectRequired"));
      return;
    }
    try {
      const res = await addApplicationCategoryDataCategory(categoryId, selectedId);
      if (res?.result === "NG") {
        notify.error(res.errorMessage || t("message.create.error"));
        return;
      }
      notify.success(t("message.create.success"));
      navigate(`${basePath}/data-categories`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t("applicationCategory.dataCategories")}：{t("common.add")}
      </Typography>
      <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 480 }}>
        <FormControl fullWidth required sx={{ mb: 3 }}>
          <InputLabel>{t("applicationCategory.dataCategoryName")}</InputLabel>
          <Select value={selectedId} onChange={(e) => setSelectedId(e.target.value)}
            label={t("applicationCategory.dataCategoryName")}>
            {dataCategories.map((dc) => (
              <MenuItem key={dc.dataCategoryId} value={dc.dataCategoryId}>
                {dc.dataCategoryName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box sx={{ display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.add")}</Button>
          <Button variant="outlined" onClick={() => navigate(`${basePath}/data-categories`)}>
            {t("common.cancel")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
